/**
 * Danh mục loại đối tượng
 * ndhieu3 20.04.2023
 */
export default {
  AccountingObjectCategory: {
    Object: 'Đối tượng',
  },
  AccountingObjectCategoryDetail: {
    CategoryName: 'Tên loại *',
  },
};
